import {selector} from './selector';
import * as events from "./events";

const PageCustomerProfileCards = (function ($) {

    function checkTerms() {
        $(selector.btnSubmitMK).prop('disabled', !$(selector.checkTerms).is(':checked'));
        $(selector.btnSubmitME).prop('disabled', !$(selector.checkTermsME).is(':checked'));
    }

    function initEvents() {
        $(document).on('click', selector.btnCardDelete, events.removeCardModal);
        $(document).on('click', selector.btnChangeDefault, events.setDefaultCard);
    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerProfileCards};